(function(){
  var TAG_LABELS={vegan:'Vegan',vegetarian:'Vegetarian','dairy-free':'Dairy-Free','nut-free':'Nut-Free',halal:'Halal','no-preservative':'No Preservatives'};
  var overlay,imgEl,titleEl,badgesEl,descEl,priceEl,addBtn,viewLink,closeBtn;
  var cache={};
  function money(c){return 'RM'+(c/100).toFixed(2);}
  function build(){
    overlay=document.createElement('div');
    overlay.className='vc-pinfo-ov';
    overlay.hidden=true;
    overlay.innerHTML='<div class="vc-pinfo" role="dialog" aria-modal="true" aria-label="Product details">'+
      '<button type="button" class="vc-pinfo-close" aria-label="Close">&times;</button>'+
      '<div class="vc-pinfo-img"><img alt=""></div>'+
      '<div class="vc-pinfo-body">'+
        '<h3></h3>'+
        '<div class="vc-pinfo-badges"></div>'+
        '<p class="vc-pinfo-desc"></p>'+
        '<div class="vc-pinfo-pr"></div>'+
        '<button type="button" class="btn btn-accent btn-block vc-quick-add" data-vid="">Add to cart</button>'+
        '<a class="btn btn-ghost btn-block" target="_blank" rel="noopener" style="margin-top:8px;display:block;text-align:center">View full details</a>'+
      '</div>'+
    '</div>';
    document.body.appendChild(overlay);
    imgEl=overlay.querySelector('img');
    titleEl=overlay.querySelector('h3');
    badgesEl=overlay.querySelector('.vc-pinfo-badges');
    descEl=overlay.querySelector('.vc-pinfo-desc');
    priceEl=overlay.querySelector('.vc-pinfo-pr');
    addBtn=overlay.querySelector('.vc-quick-add');
    viewLink=overlay.querySelector('a');
    closeBtn=overlay.querySelector('.vc-pinfo-close');
    overlay.addEventListener('click',function(e){if(e.target===overlay)close();});
    closeBtn.addEventListener('click',close);
    addBtn.addEventListener('click',function(){close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&overlay&&!overlay.hidden)close();});
  }
  function open(){overlay.hidden=false;requestAnimationFrame(function(){overlay.classList.add('is-open');});}
  function close(){overlay.classList.remove('is-open');setTimeout(function(){overlay.hidden=true;},200);}
  function populate(p){
    var img=p.featured_image||(p.images&&p.images[0])||'';
    if(img&&img.indexOf('//')===0)img='https:'+img;
    imgEl.src=img;imgEl.alt=p.title;
    titleEl.textContent=p.title;
    var tmp=document.createElement('div');tmp.innerHTML=p.description||'';
    var acc=tmp.querySelector('.accordion');
    if(acc)acc.remove();
    descEl.textContent=(tmp.textContent||'').trim();
    priceEl.textContent=money(p.price);
    badgesEl.innerHTML='';
    (p.tags||[]).forEach(function(t){var label=TAG_LABELS[t];if(label){var span=document.createElement('span');span.className='vc-diet-pill';span.textContent=label;badgesEl.appendChild(span);}});
    var vid=p.variants&&p.variants[0]&&p.variants[0].id;
    addBtn.setAttribute('data-vid',vid||'');
    addBtn.disabled=!vid;
    viewLink.href=p.url;
  }
  function showFor(handle){
    if(!overlay)build();
    open();
    if(cache[handle]){populate(cache[handle]);return;}
    titleEl.textContent='Loading…';descEl.textContent='';badgesEl.innerHTML='';priceEl.textContent='';imgEl.src='';addBtn.disabled=true;
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){cache[handle]=p;populate(p);}).catch(function(){close();});
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('a.vc-inc-item');
    if(!a)return;
    var href=a.getAttribute('href')||'';
    var m=href.match(/\/products\/([^\/?#]+)/);
    if(!m)return;
    e.preventDefault();
    showFor(m[1]);
  });
})();
